import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectSoftwareCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-issue-navigator-custom-embed',
	path: '/jira/software/projects/:projectKey/issues/:navigationItemId/embed',
};
